const DOMAIN_MAP = {
  "heygen": "heygen.com",
  "abacus ai": "abacus.ai",
  "meta ai": "meta.ai",
  "manus": "manus.im",
  "ollama": "ollama.com",
  "notion": "notion.so",
  "gamma": "gamma.app",
  "speechify": "speechify.com",
  "openclaw": "openclaw.io",
  "21st.dev": "21st.dev",
  "cursor": "cursor.com",
  "warp.dev": "warp.dev",
  "windsurf": "codeium.com",
  "lovable.dev": "lovable.dev",
  "replit": "replit.com",
  "emergent": "emergent.ai",
  "claude": "claude.ai",
  "gemini": "gemini.google.com",
  "perplexity.ai": "perplexity.ai",
  "n8n.io": "n8n.io",
  "chatgpt": "chat.openai.com",
  "claude code": "claude.ai",
  "higgsfield ai": "higgsfield.ai",
  "google antigravity": "antigravity.google",
  "openai codex": "openai.com",
  "elevenlabs": "elevenlabs.io",
  "notebooklm": "notebooklm.google",
  "comet": "comet.com",
  "canva": "canva.com",
  "open router": "openrouter.ai",
  "hugging face": "huggingface.co",
  "stich": "stitch.google",
  "figma": "figma.com",
  "v0": "v0.dev",
  "microsoft 365": "microsoft.com",
  "coursera": "coursera.org",
  "grammarly": "grammarly.com",
  "adobe creative cloud": "adobe.com",
  "firebase": "firebase.google.com",
  "jetbrains": "jetbrains.com",
  "miro": "miro.com",
  "postman": "postman.com",
  "zapier": "zapier.com",
  "behance": "behance.net",
  "duolingo": "duolingo.com",
  "freepik": "freepik.com",
  "supabase": "supabase.com",
  "groq": "groq.com",
  "bolt.new": "bolt.new",
  "requestly": "requestly.io",
  "apify": "apify.com",
  "rapidapi": "rapidapi.com",
  "tempo labs": "tempolabs.ai",
  "blackbox ai": "blackbox.ai",
  "dualite.dev": "dualite.dev",
  "cosine": "cosine.sh",
  "trae": "trae.sh",
  "riff": "riff.cc",
  "testsprite": "testsprite.com",
  "webflow": "webflow.com",
  "framer": "framer.com",
  "hostinger ai website builder": "hostinger.com",
  "tilda": "tilda.cc",
  "name.com": "name.com",
  "neo.space": "neo.space",
  "ux pilot": "uxpilot.ai",
  "base44": "base44.io",
  "easysite": "easysite.com",
  "you.com": "you.com",
  "deepseek": "deepseek.com",
  "chatprd": "chatprd.com",
  "boodlebox": "boodlebox.ai",
  "clickup": "clickup.com",
  "raycast": "raycast.com",
  "linear": "linear.app",
  "superhuman": "superhuman.com",
  "granola": "granola.so",
  "yorba": "yorba.co",
  "fyxer ai": "fyxer.ai",
  "bytedance seed": "bytedance.com",
  "together": "together.ai",
  "devin ai": "devin.ai",
  "lindy": "lindy.ai",
  "dribbble": "dribbble.com",
  "mobbin": "mobbin.com",
  "magic patterns": "magicpatterns.com",
  "appollo": "apollo.io",
  "firecrawl": "firecrawl.dev",
  "full enrich": "fullenrich.com",
  "zapdigits": "zapdigits.com",
  "make.com": "make.com",
  "phantombuster": "phantombuster.com",
  "gumloop": "gumloop.com",
  "flutterflow": "flutterflow.io",
  "edx": "edx.org",
  "datacamp": "datacamp.com",
  "brilliant": "brilliant.org",
  "jasper ai": "jasper.ai",
  "wordtune": "wordtune.com",
  "mangools": "mangools.com",
  "lex": "lex.page",
  "hootsuite": "hootsuite.com",
  "screenspace": "screenspace.io",
  "beautiful.ai": "beautiful.ai",
  "ideogram": "ideogram.ai",
  "kling ai": "klingai.com",
  "exa ai": "exa.ai",
  "restream": "restream.io"
};

const DESC_MAP = {
  "heygen": "Create engaging AI-generated videos featuring realistic avatars that speak in multiple languages. Perfect for marketing, sales, and training.",
  "abacus ai": "A cloud AI platform that automates machine learning pipelines for predictive analytics, anomaly detection, and real-time decisioning.",
  "meta ai": "An intelligent conversational assistant integrated across Meta's apps to answer questions, generate images, and assist with daily tasks.",
  "manus": "A revolutionary personal AI companion designed to help organize your life, manage schedules, and enhance personal productivity.",
  "ollama": "Run powerful open-source large language models locally on your machine with a simple setup and high performance.",
  "notion": "The connected workspace where better, faster work happens with integrated AI for writing, summarizing, and project management.",
  "gamma": "A new medium for presenting ideas. Generate beautiful, engaging presentations, webpages, and documents with AI in seconds.",
  "speechify": "The leading text-to-speech app that turns any text into natural-sounding audio for listening on the go.",
  "cursor": "An AI-powered code editor built on top of VS Code, designed for pairing with AI to write, refactor, and debug code instantly.",
  "claude": "A next-generation AI assistant built by Anthropic, known for its strong reasoning capabilities, safety, and long context window.",
  "gemini": "Google's largest and most capable AI model, built from the ground up to be multimodal and integrated into Google Workspace.",
  "perplexity.ai": "An AI-powered search engine that provides real-time, cited answers to your questions with a conversational interface.",
  "chatgpt": "OpenAI's groundbreaking conversational AI that assists with writing, coding, research, and creative brainstorming.",
  "elevenlabs": "The most realistic AI speech software available, offering high-fidelity voice cloning and multilingual text-to-speech.",
  "canva": "A comprehensive graphic design tool with powerful AI features like Magic Studio for easy image and content generation.",
  "v0": "Generate modern UI components from simple text prompts using React, Tailwind CSS, and other modern frameworks.",
  "groq": "The fastest AI inference engine, powered by LPU technology, providing near-instantaneous responses for LLMs.",
  "bolt.new": "An interactive web development sandbox where you can prompt, edit, and deploy full-stack applications with AI.",
};

export const getRealUrl = (tool) => {
  const currentUrl = tool.website_url || tool.url || "";
  if (currentUrl.includes("aixplore.in") && currentUrl.includes("slug=")) {
    try {
      const urlObj = new URL(currentUrl);
      const slug = urlObj.searchParams.get("slug");
      if (slug) {
        const known = {
          "heygen": "https://heygen.com",
          "abacus-ai": "https://abacus.ai",
          "meta-ai": "https://meta.ai",
          "manus": "https://manus.im",
          "ollama": "https://ollama.com",
          "notion": "https://notion.so",
          "gamma": "https://gamma.app",
          "speechify": "https://speechify.com",
          "cursor": "https://cursor.com",
          "windsurf": "https://codeium.com/windsurf",
          "lovable": "https://lovable.dev",
          "replit": "https://replit.com",
          "claude": "https://claude.ai",
          "gemini": "https://gemini.google.com",
          "perplexity": "https://perplexity.ai",
          "n8n": "https://n8n.io",
        };
        if (known[slug]) return known[slug];
        
        // Try DOMAIN_MAP from the top of the file
        const nameLower = tool.name.toLowerCase().trim();
        if (DOMAIN_MAP[nameLower]) {
          return `https://${DOMAIN_MAP[nameLower]}`;
        }
        
        // Final fallback: guess the domain
        return `https://${nameLower.replace(/[^a-z0-9]/g, "")}.com`;
      }
    } catch (e) {
      // do nothing
    }
  }
  return currentUrl || "#";
};

export const getRealIcon = (tool) => {
  // Find domain via map
  const nameLower = tool.name.toLowerCase().trim();
  if (DOMAIN_MAP[nameLower]) {
    return `https://www.google.com/s2/favicons?domain=${DOMAIN_MAP[nameLower]}&sz=128`;
  }

  // Try to extract from URL
  const realUrl = getRealUrl(tool);
  if (realUrl && realUrl.startsWith("http") && 
      !realUrl.includes("google.com/search") && 
      !realUrl.includes("aixplore.in") && 
      !realUrl.includes("aixploria.com")) {
    try {
      const domain = new URL(realUrl).hostname;
      return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
    } catch (e) {
      // fallback below
    }
  }

  // Fallback guess
  const domainGuess = nameLower.replace(/[^a-z0-9]/g, "") + ".com";
  return `https://www.google.com/s2/favicons?domain=${domainGuess}&sz=128`;
};

export const getRealDescription = (tool) => {
  const desc = tool.description || "";
  const isPlaceholder = desc.startsWith("Leading platform for") || desc.trim() === "";

  if (!isPlaceholder) return desc;

  const nameLower = tool.name.toLowerCase().trim();
  if (DESC_MAP[nameLower]) return DESC_MAP[nameLower];

  const cat = (tool.category || "General").toLowerCase();
  
  if (cat.includes("video")) {
    return `${tool.name} is a state-of-the-art AI-powered video generation and editing platform that helps creators produce professional content in minutes.`;
  }
  if (cat.includes("llm") || cat.includes("chat")) {
    return `${tool.name} is an advanced large language model designed to assist with coding, writing, brainstorming, and complex problem-solving.`;
  }
  if (cat.includes("image") || cat.includes("design") || cat.includes("logo")) {
    return `${tool.name} leverages cutting-edge AI to transform text prompts into stunning, high-resolution visuals and artwork.`;
  }
  if (cat.includes("developer") || cat.includes("code")) {
    return `${tool.name} streamlines your development workflow with AI-assisted coding, automated debugging, and productivity enhancements.`;
  }
  if (cat.includes("content") || cat.includes("writing")) {
    return `${tool.name} helps you craft compelling copy, blogs, and marketing materials effortlessly using advanced generative text AI.`;
  }
  if (cat.includes("productivity") || cat.includes("hr") || cat.includes("human")) {
    return `${tool.name} optimizes professional workflows, automates repetitive tasks, and enhances team collaboration with smart AI integrations.`;
  }
  if (cat.includes("marketing") || cat.includes("sales")) {
    return `${tool.name} drives growth by automating campaign creation, audience targeting, and data analytics with intelligent algorithms.`;
  }
  
  return `${tool.name} is a powerful AI solution tailored to elevate your capabilities, offering smart features to boost daily productivity.`;
};

export const getRealPricing = (tool) => {
  const price = (tool.pricing || "Not Specified").toLowerCase().trim();
  
  if (price !== "not specified") {
    if (price.includes("free") && price.includes("premium")) return "Freemium";
    if (price.includes("free") && price.includes("paid")) return "Freemium";
    if (price.includes("free")) return "Free";
    if (price.includes("paid") || price.includes("premium")) return "Paid";
    return tool.pricing; 
  }

  const nameLower = tool.name.toLowerCase().trim();
  
  const freemiumTools = [
    "chatgpt", "gemini", "claude", "perplexity", "notion", 
    "gamma", "canva", "cursor", "replit", "lovable", "bolt.new", "supabase", 
    "speechify", "v0", "figma", "github copilot", "zapier", "make.com",
    "framer", "webflow", "grammarly", "microsoft 365", "heygen", "abacus"
  ];
  
  const freeTools = [
    "meta ai", "google antigravity", "ollama", "groq", "notebooklm", 
    "hugging face", "openclaw", "claude code", "stich", "manus"
  ];
  
  if (freemiumTools.some(t => nameLower.includes(t))) return "Freemium";
  if (freeTools.some(t => nameLower.includes(t))) return "Free";
  
  return "Freemium";
};
